















import { Component, Prop, Watch } from 'vue-property-decorator';
import { ComponenteBase } from '@/views/base/ComponenteBase';
import { Funcionalidades } from '@/config/funcionalidades';

import MantenedorGridSinCodigo from '@/reusable/Grid/MantenedorGridSinCodigo.vue';
import MantenedorGrid from '@/reusable/Grid/MantenedorGrid.vue';
import { PermisoAccion } from '@/views/base/VariablesPermisos';
import {
  ColDef,
  ColumnApi,
  GridApi,
  GridOptions,
  GridReadyEvent,
  ICellRendererParams,
} from 'ag-grid-community';
import DetalleContrato from '@/pantallas/SucursalVirtual/Contratos/controllers/DetalleContratoController';
import { DatosContrato } from '@/pantallas/SucursalVirtual/Contratos/types';
import { actionsEvent } from '@/setup';
import { DetalleContrato as TypeDetalleContrato } from '@/pantallas/SucursalVirtual/Contratos/types';

@Component({
  components: {
    MantenedorGridSinCodigo,
    MantenedorGrid,
  },
})
class ContratoGrillaDetalle extends ComponenteBase {
  @Prop({ required: true }) contratoId!: DatosContrato['contratoId'];
  @Prop({ required: true }) recargarGrillaDella!: boolean;
  @Prop({ required: true }) esModoVerDetalle!: boolean;

  readonly funcionalidad = Funcionalidades.DetalleContrato;
  readonly accionesTotales: PermisoAccion[] = [
    {
      accionCodigo: 3,
      visible: false,
    },
    {
      accionCodigo: 5,
      visible: false,
    },
  ];

  columnApi: ColumnApi = null;
  gridOptions: GridOptions = null;
  gridApi: GridApi = null;
  usuarioID: string =
    JSON.parse(localStorage.getItem('user')).id.toString() || '';
  clienteDefecto: string = localStorage.getItem('clienteDefecto') || '';
  email: string = JSON.parse(localStorage.getItem('user')).email || '';
  detallesContrato: any[] = [];

  @Watch('recargarGrillaDella')
  recargarGrillaDellaFn() {
    if (this.recargarGrillaDella) {
      this.recargarGrilla();
    }
  }

  acciones() {
    const { onEditar: editarDetalle, onEliminar } = actionsEvent;
    editarDetalle(this.handleEditarDetalleContrato);
    onEliminar(this.handleEliminarDetalleContrato);
  }

  constructor() {
    super();
    // Agregar acciones
    this.acciones();

    this.gridOptions = {
      columnDefs: this.columnasGrilla(),
      pagination: true,
      paginationPageSize: 10,
      cacheBlockSize: 3,
      onGridReady: this.handleGrillaLista,
    };
  }

  private columnasGrilla(): ColDef[] {
    const columnas = [
      { headerName: 'Solución', field: 'solucion' },
      { headerName: 'Modalidad', field: 'modalidad' },
      { headerName: 'Plazo', field: 'plazo' },
      { headerName: 'Precio Servicio', field: 'precio_servicio' },
      { headerName: 'Precio Arriendo / Venta', field: 'precio_arriendo' },
      { headerName: 'Precio Instalación', field: 'precio_instalacion' },
      { headerName: 'Observación', field: 'observacion' },
    ];

    const columnasGrilla: ColDef[] = columnas.map(({ headerName, field }) => ({
      headerName,
      field,
      cellStyle: { textAlign: 'left' },
      resizable: true,
      minWidth: 100,
    }));

    return columnasGrilla;
  }

  handleGrillaLista(e: GridReadyEvent) {
    this.gridApi = e.api;
    this.columnApi = e.columnApi;
  }

  async recargarGrilla() {
    if (!this.contratoId) return;
    this.detallesContrato = await this.obtenerDetallesContratoPorId();
    this.gridApi.setRowData(this.detallesContrato);
    this.gridApi.setDomLayout('autoHeight');
  }

  async obtenerDetallesContratoPorId() {
    this.loadingService.showLoading();
    try {
      const {
        detalleContratos,
      } = await DetalleContrato.obtenerDetallesContratoPorId(this.contratoId);
      return detalleContratos;
    } catch (e) {
      this.$snotify.error((e as Error).message);
    } finally {
      this.loadingService.hideLoading();
    }
  }

  handleEditarDetalleContrato({ data }: ICellRendererParams) {
    if (!data.id_detalle) return;
    if (this.esModoVerDetalle) {
      this.$snotify.warning('No se puede editar en modo ver detalle.');
      return;
    }
    this.editarDetalleContrato(data);
  }

  editarDetalleContrato(data: any) {
    const detalleContrato: TypeDetalleContrato = {
      detalleId: data.id_detalle,
      contratoId: this.contratoId,
      solucionId: data.id_solucion,
      modalidadId: data.id_modalidad,
      plazoId: data.id_plazo,
      precioServicio: data.precio_servicio,
      precioArriendo: data.precio_arriendo,
      precioInstalacion: data.precio_instalacion,
      observacion: data.observacion,
    };
    this.$emit('onEditarDetalleContratoData', detalleContrato);
  }

  handleEliminarDetalleContrato({ data }: ICellRendererParams) {
    const { id_detalle } = data;
    if (!id_detalle) return;
    if (this.esModoVerDetalle) {
      this.$snotify.warning('No se puede eliminar en modo ver detalle.');
      return;
    }
    this.eliminarDetalleContrato(id_detalle);
  }

  async eliminarDetalleContrato(id_detalle: TypeDetalleContrato['detalleId']) {
    try {
      const { mensajeExito } = await DetalleContrato.eliminarDetalleContrato(
        id_detalle,
        this.usuarioID,
        this.clienteDefecto
      );
      this.$snotify.success(mensajeExito);
    } catch (e) {
      this.$snotify.error((e as Error).message);
    } finally {
      this.recargarGrilla();
    }
  }
}

export default ContratoGrillaDetalle;
